export const SUCCESS_GET_ALL_ROLES = 'SUCCESS_GET_ALL_ROLES';
export const FAILED_GET_ALL_ROLES = 'FAILED_GET_ALL_ROLES';


// WEBPACK FOOTER //
// ./src/state/constants/roleConstants.js